import React, { useCallback, useState } from 'react';
import {
  Button,
  ButtonFill,
  ComponentColor,
  ComponentSize,
  Dialog,
  DialogContent,
  DialogFooter,
  FdsIcon,
  Icon,
  Typography
} from '@tcc/fds';
import { getMessage } from '@tcc/i18n';
import { useRedirectUrl } from 'util/hooks/useRedirectUrl';
import { navigateToUrl } from 'util/routes';
import { printElement } from 'util/print';
import { REVIEW_AND_DOWNLOAD_CLASS_NAME } from 'create/bulk/common/constants';

export function FinishModal() {
  const [open, setOpen] = useState(false);
  const redirectUrl = useRedirectUrl();

  const onConfirm = useCallback(() => {
    navigateToUrl(redirectUrl);
  }, [redirectUrl]);

  return (
    <>
      <Button
        key="finish-recommendations-button"
        type="button"
        testId="footer-finish-button"
        fill={ButtonFill.Outline}
        color={ComponentColor.Neutral}
        onClick={() => setOpen(true)}
        size={ComponentSize.Lg}
      >
        {getMessage('button-text__complete')}
      </Button>
      <Dialog
        open={open}
        onOpenChange={setOpen}
        isModal
        headerProps={{
          title: getMessage('text__are-your-sure-you-want-to-exit'),
          titleProps: { size: ComponentSize.Lg }
        }}
      >
        <DialogContent>
          <Typography>
            {getMessage('field-level-seed-recs-finish-modal-description')}
          </Typography>
        </DialogContent>
        <DialogFooter>
          <Button
            testId="close-dialog"
            onClick={() => setOpen(false)}
            fill={ButtonFill.Outline}
            color={ComponentColor.Neutral}
          >
            {getMessage('button-text__cancel')}
          </Button>
          <Button
            testId="finish-modal-print-buton"
            color={ComponentColor.Primary}
            onClick={() => printElement({ className: REVIEW_AND_DOWNLOAD_CLASS_NAME })}
          >
            <Icon icon={FdsIcon.Print} />
            {getMessage('button-print')}
          </Button>
          <Button
            testId="confirm-dialog"
            fill={ButtonFill.Outline}
            color={ComponentColor.Primary}
            onClick={onConfirm}
          >
            {getMessage('button-text__complete')}
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
};
